import { render, staticRenderFns } from "./Outreaches.vue?vue&type=template&id=18057819&scoped=true"
import script from "./Outreaches.vue?vue&type=script&lang=js"
export * from "./Outreaches.vue?vue&type=script&lang=js"
import style0 from "./Outreaches.vue?vue&type=style&index=0&id=18057819&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18057819",
  null
  
)

export default component.exports